module.exports = __webpack_public_path__ + "static/media/medial-flexion.1865cba5.png";